//@flow

import React, { useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { SwitchTransition, CSSTransition } from "react-transition-group";

import {
  SettingsWrapper,
  SettingsHeader,
  SettingsTitle,
  SettingsDescription,
  SettingOptionsContainer,
  Error,
  FadeAnimationContainer
} from "./SharedStyledComponents";
import TopBar from "./TopBar";
import { ButtonCentered } from "../../components/ButtonDefault";
import apiMethod from "../../api/apiMethod";
import { __ } from "../../lib/translate";

type Props = {
  allSettingsBack: any,
  bodyHeight: string,
  parentRef: any
};

const DeleteLinkSetting = ({ allSettingsBack, bodyHeight, parentRef, currentSettingId }: Props) => {
  const timeNow = new Date();

  const token = useSelector(({ user }) => user.token);
  const linkData = useSelector(({ sharedLinks }) => sharedLinks.linkData);
  const { linkId } = linkData;
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successStatus, setSuccessStatus] = useState(false);

  const handleSubmit = () => {
    errorMessage && setErrorMessage("");
    setLoading(true);
    deletePublink();
  };

  const deletePublink = () => {
    const props = {
      auth: token,
      linkid: linkId
    };

    apiMethod(
      "deletepublink",
      props,
      res => {
        if (typeof gtag === "function") {
          gtag("event", "shared_link_settings_click", {
            action: "delete link",
            category: "delete",
            location: "settings modal",
          })
        }

        setLoading(false);
        setSuccessStatus(true);
      },
      {
        errorCallback: res => {
          setLoading(false);
          setErrorMessage(res.error);
        }
      }
    );
  };

  const renderHeader = () => {
    return (
      <SettingsHeader>
        <SettingsTitle>{__("Remove link")}</SettingsTitle>
        <SettingsDescription>{__("delete_link_message")}</SettingsDescription>
      </SettingsHeader>
    );
  };

  const renderBody = () => {
    return (
      <SettingOptionsContainer>
        <FadeAnimationContainer>
          <SwitchTransition>
            <CSSTransition
              key={errorMessage}
              addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
              classNames="fade"
            >
              {errorMessage ? (
                <Error style={{ textAlign: "center" }}>{__(errorMessage)}</Error>
              ) : (
                <Error />
              )}
            </CSSTransition>
          </SwitchTransition>
        </FadeAnimationContainer>
        <ButtonWrapper>
          <ButtonCentered loading={loading} borderRadius="3" color="red" onClick={handleSubmit}>
            {__("Remove")}
          </ButtonCentered>
        </ButtonWrapper>
      </SettingOptionsContainer>
    );
  };

  const renderSuccesMessage = () => {
    return <SuccessMessage>{__("your_link_has_been_removed", "Your link has been removed.")}</SuccessMessage>;
  };

  return (
    <SettingsWrapper
      overlayHeader={successStatus}
      style={{
        bottom: "0px",
        top: "auto"
      }}
      bodyHeight={bodyHeight}
      ref={parentRef}
    >
      <FadeAnimationContainer>
        <SwitchTransition>
          <CSSTransition
            key={successStatus}
            addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
            classNames="fade"
          >
            {successStatus ? (
              renderSuccesMessage()
            ) : (
              <div>
                <TopBar allSettingsBack={allSettingsBack} settingId={currentSettingId}/>
                {renderHeader()}
                {renderBody()}
              </div>
            )}
          </CSSTransition>
        </SwitchTransition>
      </FadeAnimationContainer>
    </SettingsWrapper>
  );
};

export default DeleteLinkSetting;

const ButtonWrapper = styled.div`
  margin: 0 auto;

  a {
    min-width: 120px;
  }

  a[disabled] {
    background-color: #dddddd;
    color: #a2a2a2;
    opacity: 1;
  }
`;

const SuccessMessage = styled(SettingsTitle)``;
